import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { assertIsNotSeller } from './Utils/Permission';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class DeleteSlotUseCase {
  constructor(private repo: SlotRepository) {}

  execute(id: number, current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current)) {
      throw new Error(getRestrictionMessage('삭제', current));
    }

    assertIsNotSeller(current);
    return this.repo.deleteSlot(id);
  }
}
